import React from 'react';
import './styles/normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/styles.css';

import Routes from './routes';

const App = () => (
  <Routes />
);

export default App;
